import React, { useMemo, useState } from "react";

function hueFromString(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % 360;
}

export default function Avatar({
  username,
  email,
  url,
  size = 32,
  className = "",
}) {
  const [errored, setErrored] = useState(false);
  const key = username || email || "?";
  const initial = key[0].toUpperCase();
  const hue = useMemo(() => hueFromString(key), [key]);

  if (url && !errored) {
    return (
      <img
        src={url}
        alt={username || "avatar"}
        onError={() => setErrored(true)}
        referrerPolicy="no-referrer"
        style={{ width: size, height: size }}
        className={`rounded-full object-cover shrink-0 bg-zinc-800 ${className}`}
      />
    );
  }

  return (
    <div
      style={{
        width: size,
        height: size,
        backgroundColor: `hsl(${hue}, 55%, 35%)`,
      }}
      className={`rounded-full grid place-items-center shrink-0 select-none ${className}`}
    >
      <span
        className="font-bold text-white"
        style={{ fontSize: Math.round(size * 0.45) }}
      >
        {initial}
      </span>
    </div>
  );
}
